module.exports = __webpack_public_path__ + "img/Sullivan.5601707f.png";